import { useState } from 'react';
import { RegistrationError, getRegistrationContractEndpoint } from 'cpfr-common';
import { parseErrorResponse } from '@cp-shared-19/frontend-integration';
import { WithDefaultCpIntegrationErrors } from '@cp-shared-19/common-utilities';
import { CpDataApi } from 'cp-xhr';
import { AxiosResponse } from 'axios';
import { CustomerInformation, CustomerInformationWithContract } from '../RegistrationFormDataTypes';

export interface RegistrationContractSubmissionState {
    contractNumber: string;
}

type RegistrationRequestProps = {
    isLoading: boolean;
    errorCode?: WithDefaultCpIntegrationErrors<RegistrationError>;
    data?: unknown;
};

export const useContractRegistrationSubmission = (onSuccess: (info: CustomerInformationWithContract) => void) => {
    const [registrationRequest, setRegistrationRequest] = useState<RegistrationRequestProps>({
        isLoading: false,
        errorCode: undefined,
    });

    const submit = (values: RegistrationContractSubmissionState): void => {
        setRegistrationRequest({ errorCode: undefined, isLoading: true });

        const endpoint = getRegistrationContractEndpoint(values.contractNumber);

        CpDataApi.get(endpoint)
            .then((response: AxiosResponse<CustomerInformation>) => {
                setRegistrationRequest({
                    isLoading: false,
                    data: response.data,
                });
                onSuccess({
                    ...response.data,
                    contractNumber: values.contractNumber,
                });
            })
            .catch((error) => {
                error.response.data = { ...error.response.data, status: error.response.data.response.status };
                const errorCode = parseErrorResponse<RegistrationError>(error).code;
                setRegistrationRequest({
                    isLoading: false,
                    errorCode,
                });
            });
    };
    return { submit, ...registrationRequest };
};
